import {useLayoutEffect, useState} from 'react';

export const isVisibleTourTarget = el => {
  if (!el?.isConnected) return false;
  const rect = el.getBoundingClientRect();
  const style = window.getComputedStyle(el);
  return rect.width > 0 && rect.height > 0 && style.visibility !== 'hidden' && style.display !== 'none';
};

export const useTourGeometry = (target, tooltipRef, active) => {
  const [geometry, setGeometry] = useState({rect:null, viewport:{width:window.innerWidth, height:window.innerHeight}, tooltip:{width:360, height:220}});
  useLayoutEffect(() => {
    if (!active) return;
    let frame;
    const measure = () => {
      const bounds = isVisibleTourTarget(target) ? target.getBoundingClientRect() : null;
      const rect = bounds ? {top:bounds.top, left:bounds.left, width:bounds.width, height:bounds.height} : null;
      const tooltip = tooltipRef.current?.getBoundingClientRect();
      const next = {rect, viewport:{width:window.innerWidth, height:window.innerHeight},
        tooltip:{width:tooltip?.width || Math.min(360, window.innerWidth-24), height:tooltip?.height || 220}};
      setGeometry(previous => JSON.stringify(previous) === JSON.stringify(next) ? previous : next);
      // Track smooth scrolling, nested scroll containers, sticky headers and
      // asynchronous layout changes, without mutating/cloning the target.
      frame = requestAnimationFrame(measure);
    };
    measure();
    return () => cancelAnimationFrame(frame);
  }, [target, tooltipRef, active]);
  return geometry;
};